import { render, staticRenderFns } from "./ApproveShipmentModal.vue?vue&type=template&id=60401e95&scoped=true"
import script from "./ApproveShipmentModal.vue?vue&type=script&lang=js"
export * from "./ApproveShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./ApproveShipmentModal.vue?vue&type=style&index=0&id=60401e95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60401e95",
  null
  
)

export default component.exports